export const TeamMembersEnglish = {
  title: 'Team members',
  subTitle: 'Invite your team member and manage their access type.',
  tooltipText: 'Click here to learn more about inviting team members',
  noTeamMembersFound: 'No team members found',
  editThisJob: 'Edit this job',
  sendAndViewOfferLetters: 'Send & view offer letters',
  viewSecretNotesMails: 'View confidential comments & emails',
  confidentiality: 'Confidential access cannot be removed if the collaborator is allowed to edit the job.',
  accessCandidateProfile: 'Access candidate profile',
  owner: 'Owner',
  invitedUsersNote: {
    note: 'Users who signed in or invited with the <b>{domain}</b> domain email address will show in this list.',
    noteWithMultipleDomains: 'Users who signed in or invited with the <b>{domain}</b> or {otherEmailDomain} domain email address will show in this list.',
    prefix: 'Users who signed in or invited with the',
    suffix: 'domain email address will show in this list.'
  },
  dialog: {
    email: 'Email',
    inputEmail: 'Enter email',
    firstName: 'First name',
    lastName: 'Last name',
    accessType: 'Access type',
    selectAccessType: 'Select access type',
    roleType: 'Role type',
    selectRoleType: 'Select role type',
    fullAccessDesc: {
      description: 'Complete access to add / remove members, edit all jobs, view confidential comments, candidate list, etc.',
      usageDesc: 'Typically used for talent team members.'
    },
    limitedAccessDesc: {
      description: 'Access to view jobs and candidates only when added as a collaborator to that job.',
      usageDesc: 'Typically used for hiring managers and interviewers.'
    },
    employeeDesc: {
      description: 'No access to view jobs and candidates. Only accessible to referral portal.',
      usageDesc: 'Typically used for employees.'
    },
    companyPermissions: {
      title: 'Company permissions',
      desc: 'Choose the permissions this member is allowed to access',
      accessReports: 'Access company reports',
      exportData: 'Export data',
      createOpenings: 'Submit Requisition',
      createJob: 'Create Job'
    },
    jobPermissions: {
      title: 'Job permissions',
      desc: 'Choose the jobs and permissions this member is allowed to access'
    },
    allJobs: 'All jobs',
    selectedJobs: 'Selected jobs',
    permissions: {
      deleteCandidates: 'Delete candidates',
      sendAndViewOfferLetters: 'Send and view offer letters',
      editJob: 'Edit job',
      emailsProgressArchive: 'Send emails, progress stages, or archive candidates',
      viewConfidentialNotes: 'View confidential comments and email'
    },
    allStages: 'All stages',
    selectedStages: 'Selected stages',
    assignedJobs: 'Assigned jobs',
    assignedJobNote: 'Choose the job listing(s) that this member is allowed to access and send candidates for.',
    assignMore: 'Assign more jobs',
    inviteUser: 'Invite user',
    sendInvitation: 'Send invitation again',
    sendInvite: 'Send invite',
    deleteNote: 'Are you sure you want to delete this user?',
    inviteNote: 'Are you sure you want to resend the invitation mail?'
  },
  buttons: {
    inviteNewUser: 'Invite a new user'
  },
  search: {
    nameOrEmail: 'Search by name or email',
    accessTypeText: 'Access type | Access type({length}) | Access types({length})',
    roleTypeText: 'Role type | Role type({length}) | Role types({length})',
    accessTypes: {
      COMPANY_ADMIN: 'Super Admin',
      COMPANY_RECRUITER: 'Recruiter',
      COMPANY_INTERVIEWER: 'Hiring Manager / Interviewer',
      COMPANY_EMPLOYEE: 'Employee'
    },
    descriptions: {
      COMPANY_ADMIN: 'Full access to all requisitions, jobs, candidates, reports, and settings; manage all team members.',
      COMPANY_RECRUITER: 'Access assigned requisitions, jobs, candidates, reports, and settings; manage Hiring Managers/Interviewers and Employees.',
      COMPANY_INTERVIEWER: 'Access assigned jobs, candidates in selected stages, and personal settings; cannot manage team members.',
      COMPANY_EMPLOYEE: 'No access to jobs, candidates, reports, or settings; access only the employee portal to refer candidates and apply for internal jobs.'
    },
    usageDesc: {
      COMPANY_ADMIN: 'Typically used for HR Directors, Recruitment Leads, and VPs of HR/People.',
      COMPANY_RECRUITER: 'Typically used for recruiters, recruiting coordinators, and sourcers.',
      COMPANY_INTERVIEWER: 'Typically used for hiring managers, department heads, and interviewers.',
      COMPANY_EMPLOYEE: 'Typically used for Employees.'
    }
  },
  table: {
    header: {
      fullName: 'NAME',
      roleType: 'ROLE TYPE',
      jobsAssigned: 'JOBS ASSIGNED',
      lastActive: 'LAST ACTIVE',
      status: 'STATUS',
      actions: 'ACTIONS'
    }
  },
  errors: {
    enterEmail: 'Please enter email',
    invalidEmail: 'Please enter a valid email',
    enterFirstName: 'Please enter first name',
    enterLastName: 'Please enter last name',
    invalidCompanyId: 'Invalid company ID',
    selectAccessType: 'Please select an access type',
    selectRoleType: 'Please select an role type',
    userExist: 'User email already exists',
    deleteApproverUser: {
      superAdmin: 'This user cannot be deleted as they are assigned as an approver in the hiring plan approval flow. Please remove them from the approval flow and try again.',
      recruiter: 'This user cannot be deleted because they are assigned as an approver in the hiring plan approval flow. Please contact your super admin to remove them from the approval flow and try again.'
    }
  },
  reassignOwner: 'Reassign owner',
  activeCandidateForOwnerDesc: 'There are {count} active candidates for this owner ({owner}). Do you want to reassign them to another owner.',
  successMessages: {
    invitedUser: 'Invited user successfully!',
    updatedUser: 'User updated successfully!',
    deletedUser: 'Deleted user successfully!',
    inviteSent: 'Invite sent successfully!'
  }
}

export const TeamMembersArabic = {
  title: 'أعضاء فريقك',
  subTitle: 'ادعو أعضاء فريقك وأدر نوع وصولهم.',
  tooltipText: 'انقر هنا لـ تعرف على المزيد حول دعوة أعضاء الفريق',
  noTeamMembersFound: 'لم يتم العثور على أعضاء في الفريق',
  invitedUsersNote: {
    prefix: 'يظهر في هذه القائمة المستخدمين الذين سجلوا دخولهم أو تمت دعوتهم باستخدام',
    suffix: 'الايميل.'
  },
  dialog: {
    email: 'البريد الإلكتروني',
    inputEmail: 'ادخل البريد الإلكتروني',
    firstName: 'الاسم الأول',
    lastName: 'الاسم الأخير',
    accessType: 'نوع الإذن',
    selectAccessType: 'اختر نوع الإذن',
    roleType: 'نوع الدور',
    selectRoleType: 'حدد نوع الدور',
    fullAccessDesc: {
      description: 'إذن كامل بإضافة / إزالة الأعضاء، والتعديل على الوظائف، وعرض الملاحظات الخفية وقائمة المرشحين، إلخ.',
      usageDesc: 'عادةً ما يُستخدم لأعضاء فريق جذب المواهب.'
    },
    limitedAccessDesc: {
      description: 'إذن بعرض الوظائف والمرشحين فقط عند إضافته كموظف متعاون.',
      usageDesc: 'عادةً ما يُستخدم لمديري التوظيف والقائمين على إجراء مقابلات التوظيف.'
    },
    employeeDesc: {
      description: 'إذن بالوصول إلى بوابة الترشيح والتزكية فقط، ولا يوجد إذن لعرض الوظائف والمرشحين.',
      usageDesc: 'عادةً ما يُستخدم للموظفين.'
    },
    companyPermissions: {
      title: 'أذونات الشركة',
      desc: 'اختر الأذونات المسموح لهذا العضو بالوصول إليها',
      accessReports: 'الوصول إلى تقارير الشركة',
      exportData: 'تصدير البيانات',
      createOpenings: 'تقديم طلب فتح',
      createJob: 'إنشاء وظيفة'
    },
    jobPermissions: {
      title: 'أذونات الوظيفة',
      desc: 'اختر الوظائف والأذونات المسموح لهذا العضو بالوصول إليها'
    },
    allJobs: 'جميع الوظائف',
    selectedJobs: 'وظائف مختارة',
    permissions: {
      deleteCandidates: 'حذف المرشحين',
      sendAndViewOfferLetters: 'إرسال وعرض خطابات العرض',
      editJob: 'تعديل الوظيفة',
      emailsProgressArchive: 'إرسال البريد الإلكتروني، أو التقدم في المراحل أو أرشفة المرشحين',
      viewConfidentialNotes: 'عرض الملاحظات السرية والبريد الإلكتروني'
    },
    allStages: 'جميع المراحل',
    selectedStages: 'المراحل المختارة',
    assignedJobs: 'الوظائف المعينة',
    assignedJobNote: 'اختر قائمة الوظائف التي يُسمح لهذا العضو بالوصول إليها وإرسال المرشحين إليه.',
    assignMore: 'تعيين وظيفة أخرى',
    inviteUser: 'دعوة مستخدم',
    sendInvitation: 'إعادة إرسال الدعوة',
    sendInvite: 'إرسال دعوة',
    inviteNote: 'هل أنت متأكد من إعادة إرسال الدعوة؟',
    deleteNote: 'هل أنت متأكد من حذف هذا المستخدم؟'
  },
  buttons: {
    inviteNewUser: 'دعوة مستخدم جديد'
  },
  search: {
    nameOrEmail: 'البحث بالاسم أو الايميل',
    accessTypeText: 'أنواع الوصول({length}) | أنواع الوصول({length}) | نوع الوصول',
    roleTypeText: 'نوع الدور | نوع الدور({length}) | أنواع الأدوار({length})',
    accessTypes: {
      COMPANY_RECRUITER: 'مسؤول التعيين',
      COMPANY_INTERVIEWER: 'مدير التوظيف/المُقَابِل',
      COMPANY_ADMIN: 'مشرف أعلى',
      COMPANY_EMPLOYEE: 'موظف'
    },
    descriptions: {
      COMPANY_ADMIN: 'الوصول الكامل إلى جميع الطلبات الافتتاحية والوظائف والمرشحين والتقارير والإعدادات؛ إدارة جميع أعضاء الفريق.',
      COMPANY_RECRUITER: 'الوصول إلى الطلبات الافتتاحية والوظائف والمرشحين والتقارير والإعدادات المخصصة؛ إدارة مديري التوظيف / المقابلات والموظفين.',
      COMPANY_INTERVIEWER: 'الوصول إلى الوظائف المعينة، والمرشحين في مراحل مختارة، والإعدادات الشخصية؛ لا يستطيع إدارة أعضاء الفريق.',
      COMPANY_EMPLOYEE: 'لا يمكن الوصول إلى الوظائف أو المرشحين أو التقارير أو الإعدادات؛ الوصول فقط إلى بوابة الموظف لإحالة المرشحين والتقدم للوظائف الداخلية.'
    },
    usageDesc: {
      COMPANY_ADMIN: 'يُستخدم عادةً لمديري الموارد البشرية وقادة التوظيف ونواب الموارد البشرية/الأفراد.',
      COMPANY_RECRUITER: 'يُستخدم عادةً للقائمين بالتوظيف، ومنسقي التوظيف، والمصادر.',
      COMPANY_INTERVIEWER: 'يُستخدم عادةً لمديري التوظيف ورؤساء الأقسام والمقابلات.',
      COMPANY_EMPLOYEE: 'تستخدم عادة للموظفين.'
    }
  },
  table: {
    header: {
      fullName: 'الاسم',
      roleType: 'نوع الدور',
      jobsAssigned: 'الوظائف المعينة للموظف',
      lastActive: 'آخر نشاط للموظف',
      status: 'حالة الموظف',
      actions: 'إجراءات'
    }
  },
  errors: {
    enterEmail: 'الرجاء إدخال الايميل',
    invalidEmail: 'الرجاء إدخال ايميل صحيح',
    enterFirstName: 'الرجاء إدخال الاسم الأول',
    enterLastName: 'الرجاء إدخال الاسم الأخير',
    invalidCompanyId: 'معرف الشركة غير صحيح',
    selectAccessType: 'الرجاء تحديد نوع الإذن',
    selectRoleType: 'الرجاء تحديد نوع الدور',
    userExist: 'ايميل هذا المستخدم موجود بالفعل',
    deleteApproverUser: {
      superAdmin: 'لا يمكن حذف هذا المستخدم لأنه تم تعيينه كمعتمد في تدفق الموافقة على خطة التوظيف. الرجاء إزالتها من عملية الموافقة والمحاولة مرة أخرى.',
      recruiter: 'لا يمكن حذف هذا المستخدم لأنه تم تعيينه كمعتمد في تدفق الموافقة على خطة التوظيف. يُرجى الاتصال بالمشرف المتميز لإزالته من عملية الموافقة والمحاولة مرة أخرى.'
    }
  },
  reassignOwner: 'إعادة تعيين المالك',
  activeCandidateForOwnerDesc: 'هناك {count} مرشح نشط لهذا المالك ({owner}). هل تريد إعادة تعيينهم إلى مالك آخر؟',
  successMessages: {
    invitedUser: 'تمت دعوة المستخدم بنجاح!',
    updatedUser: 'تم تحديث حالة المستخدم بنجاح!',
    deletedUser: 'تم حذف المستخدم بنجاح.',
    inviteSent: 'تم إرسال الدعوة بنجاح!'
  }
}
